/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IWineFinderByZipViewProps } from './wine-finder-by-zip';

/**
 * Class definition responsible for redirecting to findusawine.com to find local wine retailers based on the user inputted zipcode
 */
@observer
export class WineFinderByZipView extends React.Component<IWineFinderByZipViewProps, { value: string }> {
    /**
     * field representing the location being typed in by the user
     */
    @observable private _queryZipcode: string = '';

    public constructor(props: IWineFinderByZipViewProps) {
        super(props);
        this._handleQueryZipcodeChange = this._handleQueryZipcodeChange.bind(this);
        this._keyup = this._keyup.bind(this);
        this._doQuery = this._doQuery.bind(this);
    }

    public render(): JSX.Element | null {
        return (
            <div className='wine-finder-by-zip-query'>
                <label htmlFor='zipcode'>Enter zip code to buy local</label>
                <input
                    id='zipcode'
                    type='text'
                    className='wine-finder-by-zip-input'
                    placeholder='Enter Zip'
                    value={this._queryZipcode}
                    onChange={this._handleQueryZipcodeChange}
                    onKeyUp={this._keyup}
                />
                <button className='wine-finder-by-zip-search-button' disabled={this._isInvalid()} onClick={this._doQuery}>Search</button>
            </div>
        );
    }

    /**
     * handles changes for the zipcode entered
     */
    private _handleQueryZipcodeChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this._queryZipcode = event.target.value;
    }

    /**
     * checks if the enter/return key has been pressed to submit a zipcode query
     */
    private _keyup(event: React.KeyboardEvent<HTMLInputElement>): void {
        if (event.keyCode === 13 && !this._isInvalid()) {
            this._doQuery();
        }
    }

    /**
     * process to disable the Search button if the user's text input is not a 5 digit entry (findusawine.com does not support 9 digit zip codes)
     */
    private _isInvalid(): boolean {
        const regex = /^\d{5}$/;
        return (!regex.test(this._queryZipcode));
    }

    /**
     * process to send the zip code query to findusawine.com
     */
    private _doQuery(): void {
        window.open(`https://www.findusawine.com/${this.props.config.wineBrandUrl}/locate/domestic-results?location=${this._queryZipcode}&product_key=&header=&retail=true&restaurant=true`, '_blank');
    }

}

export default WineFinderByZipView;